import * as URI from 'urijs';
import { ENV } from '@sitegen/common/constants/environments';

export const USER_IMAGE_SRC_CONSTANTS = {
    IMAGE: '/default_146_146.png',
    SRC_ROOT: 'ubisoft-avatars.akamaized.net/',
    ENV_PREFIX: {
        [ENV.QC]: 'uat-',
        [ENV.DEV]: 'uat-',
        [ENV.UAT]: 'uat-',
        [ENV.PREPROD]: '',
        [ENV.PROD]: ''
    }
};
export const buildUserImageSrc = (env: ENV | string, userID: string): string => {
    const host: string = `${USER_IMAGE_SRC_CONSTANTS.ENV_PREFIX[env]}${USER_IMAGE_SRC_CONSTANTS.SRC_ROOT}`;
    const url: URI = new URI().protocol('https').hostname(host).segment([userID || '', USER_IMAGE_SRC_CONSTANTS.IMAGE]);
    return url.href();
};
